import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Asset } from "../../all_Interfaces";


interface InitialState {
    data: Asset[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: [] as Asset[],
    error: '',
    loading: false
}

const investmentAssetSlice = createSlice({
    name: "investmentAsset",
    initialState,
    reducers: {
        updateInvestmentAsset(state, action: PayloadAction<Asset[]>) {
            state.data = action.payload;
        },
    },
});

export const { updateInvestmentAsset } = investmentAssetSlice.actions;

export default investmentAssetSlice.reducer;